import { baseApi } from '@/shared/api'
import { ReturnNoteListDto, ReturnNoteDto } from './types'
import { DeliveryNoteResponse, CreateDeliveryNoteRequest } from './types'
import { AssetTypeHistoryDto } from './types'
import { DELIVERY_NOTE_TAG } from '@/shared/api/tags'

export const deliveryNoteApi = baseApi.injectEndpoints({
  endpoints: build => ({
    createDeliveryNote: build.mutation<
      DeliveryNoteResponse,
      CreateDeliveryNoteRequest
    >({
      query: body => ({
        url: `/work-orders/${body.workOrderId}/delivery-notes`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [DELIVERY_NOTE_TAG],
    }),
    updateDeliveryNote: build.mutation<
      DeliveryNoteResponse,
      CreateDeliveryNoteRequest
    >({
      query: body => ({
        url: `work-orders/${body.work_order_id}/delivery-notes/${body.id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [DELIVERY_NOTE_TAG],
    }),
    getDeliveryNote: build.query<
      DeliveryNoteResponse,
      { workOrderId: number; deliveryNoteId: number }
    >({
      query: ({ workOrderId, deliveryNoteId }) => ({
        url: `/work-orders/${workOrderId}/delivery-notes/${deliveryNoteId}`,
        method: 'GET',
      }),
      providesTags: result => [{ type: DELIVERY_NOTE_TAG, id: result?.id }],
      transformResponse: response => response.data,
    }),
    listDeliveryNotes: build.query<
      DeliveryNoteResponse[],
      {
        workOrderId: number
        page?: number
        per_page?: number
        search?: string
        sort_field?: string
        order?: string
      }
    >({
      query: ({ workOrderId, ...params }) => ({
        url: `/work-orders/${workOrderId}/delivery-notes`,
        method: 'GET',
        params,
      }),
      providesTags: [DELIVERY_NOTE_TAG],
    }),
    // fetchAssetTypeHistoryById: build.query<AssetTypeHistoryDto, number>({
    //   query: assetTypeId => `/inventory/asset-types/${assetTypeId}/history`,
    // }),
  }),
})

export const {
  useCreateDeliveryNoteMutation,
  useUpdateDeliveryNoteMutation,
  useGetDeliveryNoteQuery,
  useListDeliveryNotesQuery,
  // useFetchAssetTypeHistoryByIdQuery,
} = deliveryNoteApi
